module.exports = __webpack_public_path__ + "media/stylesheets/images/mattrz_lp/logos/logo-24-7f50b13f66a9b5a553f28d03181927d0.png";